@if (!isAuthorized() || isAuthorizedHeaderLocked()) {
  <div class="header-no-register">
    <div class="header-no-register__wrapper">
      <div class="logo logo--partner" [class.logo--static]="isHeaderNavigationLocked()">
        @if (!isHeaderNavigationLocked()) {
          <a href="/">
            <ng-container *ngTemplateOutlet="logo" />
          </a>
        } @else {
          <ng-container *ngTemplateOutlet="logo" />
        }
      </div>
    </div>
  </div>
}

<ng-template #logo>
  <img src="./assets/img/logo.svg?v=1" alt="">
</ng-template>
